
import React from "react";
import { Link } from "react-router-dom";
import {
  Instagram,
  Facebook,
  Youtube,
  Linkedin,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import Logo from "../../images/Dhroom White.svg";

const Landing_Footer = () => {
  return (
    <>
      <style>{`
        .footer {
          background: #1E1B4B;
          padding: 2.5rem 0;
        }

        .footer-container {
          max-width: 1600px;
          margin: 0 auto;
          padding: 0 6rem;
        }

        /* ===== TOP GRID ===== */
        .footer-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1.2fr;
          gap: 2.5rem;
          align-items: flex-start;
        }

        /* LEFT */
        .footer-left {
          display: flex;
          flex-direction: column;
        }

        .footer-logo {
          width: 160px;
          margin-bottom: 12px;
        }

        .footer-desc {
          font-size: 1rem;
          line-height: 1.6;
          max-width: 480px;
          color: #ffffff;
        }

        /* CENTER (FEATURES) */
        .footer-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          color: #ffffff;
        }

        .footer-title {
          font-weight: 700;
          font-size: 1.05rem;
          margin-bottom: 12px;
          margin-top: 20px;
        }

        .footer-feature-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-feature-list li {
          margin-bottom: 8px;
        }

        .footer-feature-list a {
          color: #ffffff;
          text-decoration: none;
          font-size: 0.95rem;
        }

        // .footer-feature-list a:hover {
        //   color: #2F2CD8;
        // }

        /* RIGHT (OFFICE DETAILS) */
        .footer-right {
          display: flex;
          flex-direction: column;
          gap: 12px;
          color: #ffffff;
        }

        .footer-right-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-size: 0.95rem;
          line-height: 1.4;
        }

        .footer-right-item a {
          color: #ffffff;
          text-decoration: none;
        }

        // .footer-right-item a:hover {
        //   color: #2F2CD8;
        // }

        /* SOCIALS */
        .footer-socials {
          display: flex;
          gap: 0.8rem;
          margin-top: 12px;
        }

        .social-circle {
          background: #ffffff;
          border-radius: 50%;
          width: 38px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .social-icon {
          color: #2F2CD8;
          width: 20px;
          height: 20px;
        }

        /* ===== BOTTOM ===== */
        .footer-bottom {
          border-top: 1px solid #ffffff;
          margin-top: 2rem;
          padding-top: 1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        }

        .footer-copy {
          font-size: 0.85rem;
          color: #ffffff;
        }

        .footer-bottom-links {
          display: flex;
          gap: 0.8rem;
        }

        .footer-bottom-link {
          color: #ffffff;
          text-decoration: none;
          font-size: 0.9rem;
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 992px) {
          .footer-grid {
            grid-template-columns: 1fr;
            text-align: center;
          }

          .footer-left,
          .footer-right {
            align-items: center;
          }

          .footer-right-item {
            justify-content: center;
          }
        }

        @media (max-width: 576px) {
          .footer-container {
             padding: 2rem 2rem;
          }

          .footer-bottom {
            flex-direction: column;
            gap: 10px;
          }

          .footer-bottom-links {
            justify-content: center;
            flex-wrap: wrap;
          }
            .footer {
          padding: 0rem;
          bottom: 80px;
        }
          .custom_chat_container {
            bottom: 42px; 
            right: 8px;
            }
             .custom_chat_button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
        }

        .chatbot_owl_image{
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
      `}</style>

      <footer className="footer">
        <div className="footer-container">

          {/* TOP */}
          <div className="footer-grid">

            {/* LEFT */}
            <div className="footer-left">
              <Link to="/" style={{ textDecoration: "none" }}>
                <img src={Logo} alt="logo" className="footer-logo" />
              </Link>
              <p className="footer-desc">
                Dhroom helps businesses run powerful WhatsApp & SMS
                marketing campaigns with automation, analytics, and
                enterprise-grade reliability.
              </p>
            </div>

            {/* CENTER */}
            <div className="footer-center">
              <h3 className="footer-title">Features</h3>
              <ul className="footer-feature-list">
                <li><Link to="/whatsapp-campaign">WhatsApp Campaign</Link></li>
                <li><Link to="/audiance-targeting">Audiance Targeting</Link></li>
                <li><Link to="/personalized-message">Personalized Message</Link></li>
                <li><Link to="/automated-replies">Automated Replies</Link></li>
              </ul>
            </div>

            {/* RIGHT */}
            <div className="footer-right">
              <h3 className="footer-title">Office Details</h3>

              <div className="footer-right-item">
                <MapPin size={18} />
                <span>
                  2nd Floor, Ithum,Tower,<br />
                  Sector 62, Noida,<br />
                  Uttar Pradesh – 201301
                </span>
              </div>

              <div className="footer-right-item">
                <Mail size={18} />
                <a href="mailto:support@dhroom.com">
                  support@dhroom.com
                </a>
              </div>

              <div className="footer-right-item">
                <Phone size={18} />
                <a href="tel:+919910254756">
                  +91 9910254756
                </a>
              </div>

              {/* SOCIAL ICONS */}
              <div className="footer-socials">
                <div className="social-circle">
                  <Instagram className="social-icon" />
                </div>
                <div className="social-circle">
                  <Facebook className="social-icon" />
                </div>
                <div className="social-circle">
                  <Youtube className="social-icon" />
                </div>
                <div className="social-circle">
                  <Linkedin className="social-icon" />
                </div>
              </div>
            </div>

          </div>

          {/* BOTTOM */}
          <div className="footer-bottom">
            <div className="footer-copy">
              © {new Date().getFullYear()} Dhroom. All rights reserved.
            </div>

            <div className="footer-bottom-links">
              <Link to="/terms&conditions" className="footer-bottom-link">
                Terms & Conditions
              </Link>
              <Link to="/PrivacyPolicy" className="footer-bottom-link">
                Privacy Policy
              </Link>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
};

export default Landing_Footer;

